import MainLayout from "layouts/Main";
import { settingsTabs } from "views/Dashboard/Settings/tabs";

import GOGroupsTable from "./GOGroupsTable";

const Users = () => {
  return (
    <MainLayout tabs={settingsTabs}>
      <GOGroupsTable />
    </MainLayout>
  );
};

export default Users;
